import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "d-sm-flex align-items-center" };
const _hoisted_4 = { class: "d-flex align-items-center" };
const _hoisted_5 = ["placeholder"];
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_7 = { class: "table-responsive" };
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = {
    colspan: "8",
    class: "text-center py-4"
};
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0 text-capitalize" };
const _hoisted_12 = { class: "d-flex align-items-center text-capitalize" };
const _hoisted_13 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "shadow-none badge text-bg-warning fs-13 lh-1 fw-medium text-black" };
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_19 = {
    key: 0,
    class: "shadow-none badge text-bg-danger fs-13 fs-13 lh-1 fw-medium text-white"
};
const _hoisted_20 = {
    key: 1,
    class: "shadow-none badge text-bg-success fs-13 lh-1 fw-medium text-white"
};
const _hoisted_21 = {
    key: 2,
    class: "shadow-none lh-1 fw-medium text-muted"
};
const _hoisted_22 = {
    key: 3,
    class: "shadow-none lh-1 fw-medium text-muted"
};
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" };
const _hoisted_25 = { class: "dropdown" };
const _hoisted_26 = { class: "dropdown-menu" };
const _hoisted_27 = ["onClick"];
const _hoisted_28 = ["onClick"];
const _hoisted_29 = ["onClick"];
const _hoisted_30 = { key: 2 };
const _hoisted_31 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" };
const _hoisted_32 = { class: "mb-0 text-paragraph" };
const _hoisted_33 = { class: "mt-15 mt-md-0" };
const _hoisted_34 = { class: "pagination mb-0" };
const _hoisted_35 = ["onClick"];
const _hoisted_36 = {
    class: "modal fade",
    id: "historyModal",
    tabindex: "-1",
    "aria-labelledby": "historyModalLabel",
    "aria-hidden": "true"
};
const _hoisted_37 = { class: "modal-dialog modal-lg modal-dialog-centered" };
const _hoisted_38 = { class: "modal-content border-0 rounded-0 bg-white" };
const _hoisted_39 = { class: "modal-header p-20 p-md-25" };
const _hoisted_40 = {
    class: "modal-title fw-bold",
    id: "historyModalLabel"
};
const _hoisted_41 = { class: "modal-body p-20 p-md-25" };
const _hoisted_42 = {
    key: 0,
    class: "text-center py-5"
};
const _hoisted_43 = {
    key: 1,
    class: "text-center py-5"
};
const _hoisted_44 = {
    key: 2,
    class: "table-responsive"
};
const _hoisted_45 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_46 = { class: "shadow-none lh-1 fw-medium text-black-emphasis ps-0" };
const _hoisted_47 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_48 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_49 = { class: "shadow-none lh-1 fw-medium text-muted text-end pe-0" };
const _hoisted_50 = { class: "badge text-bg-light border" };
const _hoisted_51 = {
    class: "modal fade",
    id: "confirmModal",
    tabindex: "-1",
    "aria-labelledby": "confirmModalLabel",
    "aria-hidden": "true"
};
const _hoisted_52 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_53 = { class: "modal-content" };
const _hoisted_54 = { class: "modal-body text-center" };
const _hoisted_55 = { class: "mb-0" };
const _hoisted_56 = { class: "modal-footer" };
const _hoisted_57 = {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_EmptyTable = _resolveComponent("EmptyTable");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.gotoCreate && _ctx.gotoCreate(...args))),
                        class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                        type: "button"
                    }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('lists.addCoupon')) + " ", 1),
                        _cache[7] || (_cache[7] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("form", {
                        class: "search-box position-relative me-15",
                        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["prevent"]))
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.searchQuery) = $event)),
                            type: "text",
                            class: "form-control shadow-none text-black rounded-0 border-0",
                            placeholder: _ctx.$t('lists.searchCoupon'),
                            onInput: _cache[2] || (_cache[2] = ($event) => (_ctx.currentPage = 1))
                        }, null, 40, _hoisted_5), [
                            [_vModelText, _ctx.searchQuery]
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("button", {
                            type: "submit",
                            class: "bg-transparent text-primary transition p-0 border-0"
                        }, [
                            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                        ], -1))
                    ], 32)
                ])
            ]),
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                        _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                                }, " ID "),
                                _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, " CODE COUPON "),
                                _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, " TYPE "),
                                _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, " VALEUR "),
                                _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, " LIMITE D'UTILISATION "),
                                _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, " ETAT "),
                                _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, " NOMBRE D'UTILISATION "),
                                _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                }, " CRÉER LE "),
                                _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                                })
                            ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                            (_ctx.isLoading)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                                    _createElementVNode("td", _hoisted_10, [
                                        _createVNode(_component_LoaderComponent)
                                    ])
                                ]))
                                : (!_ctx.isLoading && _ctx.allCategorie.length > 0)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.allCategorie, (categorie, index) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: categorie.id
                                        }, [
                                            _createElementVNode("th", _hoisted_11, [
                                                _createElementVNode("div", _hoisted_12, [
                                                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "form-check mb-0 text-capitalize" }, [
                                                        _createElementVNode("input", {
                                                            class: "form-check-input shadow-none",
                                                            type: "checkbox"
                                                        })
                                                    ], -1)),
                                                    _createElementVNode("div", _hoisted_13, [
                                                        _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: ($event) => (_ctx.selectForDetail(categorie))
                                                        }, _toDisplayString(index + 1) + " - " + _toDisplayString(_ctx.getShortUuid(categorie.id)), 9, _hoisted_14)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_15, _toDisplayString(categorie.code), 1),
                                            _createElementVNode("td", _hoisted_16, _toDisplayString(categorie.discount_type === "fixed" ? "Fixe" : "Pourcentage"), 1),
                                            _createElementVNode("td", _hoisted_17, _toDisplayString(categorie.discount_type === "fixed"
                                                ? `${categorie.discount_value} CHF`
                                                : `${categorie.discount_value}%`), 1),
                                            _createElementVNode("td", _hoisted_18, _toDisplayString(categorie.usage_limit), 1),
                                            (categorie.is_used)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_19, " Utilisé "))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_20, " Valide ")),
                                            (categorie.orders)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(categorie.orders?.length || 0), 1))
                                                : (_openBlock(), _createElementBlock("td", _hoisted_22, "-")),
                                            _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.convertDateCreate(categorie.created_at)), 1),
                                            _createElementVNode("td", _hoisted_24, [
                                                _createElementVNode("div", _hoisted_25, [
                                                    _cache[13] || (_cache[13] = _createElementVNode("button", {
                                                        class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                                        type: "button",
                                                        "data-bs-toggle": "dropdown",
                                                        "aria-expanded": "false"
                                                    }, [
                                                        _createElementVNode("i", { class: "flaticon-dots" })
                                                    ], -1)),
                                                    _createElementVNode("ul", _hoisted_26, [
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.selectForDetail(categorie))
                                                            }, [...(_cache[10] || (_cache[10] = [
                                                                    _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                                                    _createTextVNode(" Voir", -1)
                                                                ]))], 8, _hoisted_27)
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                "data-bs-toggle": "modal",
                                                                "data-bs-target": "#historyModal",
                                                                href: "#",
                                                                onClick: ($event) => (_ctx.fetchHistory(categorie))
                                                            }, [...(_cache[11] || (_cache[11] = [
                                                                    _createElementVNode("i", { class: "flaticon-file-1 lh-1 me-8 position-relative top-1" }, null, -1),
                                                                    _createTextVNode(" Historique", -1)
                                                                ]))], 8, _hoisted_28)
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                "data-bs-toggle": "modal",
                                                                "data-bs-target": "#confirmModal",
                                                                href: "#",
                                                                onClick: ($event) => (_ctx.prepareDelete(categorie))
                                                            }, [...(_cache[12] || (_cache[12] = [
                                                                    _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                                                    _createTextVNode(" Supprimer", -1)
                                                                ]))], 8, _hoisted_29)
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ]));
                                    }), 128))
                                    : (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                                        _createVNode(_component_EmptyTable, {
                                            message: "Aucun coupon pour le moment",
                                            colspan: 8,
                                            textClass: "text-muted"
                                        })
                                    ]))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.paginationInfo), 1),
                    _createElementVNode("nav", _hoisted_33, [
                        _createElementVNode("ul", _hoisted_34, [
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Previous",
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.changePage(_ctx.currentPage - 1)), ["prevent"]))
                                }, [...(_cache[15] || (_cache[15] = [
                                        _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                    ]))])
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generatePageNumbers(), (page) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: page,
                                    class: _normalizeClass(["page-item", { active: page === _ctx.currentPage }])
                                }, [
                                    _createElementVNode("a", {
                                        class: "page-link",
                                        href: "#",
                                        onClick: _withModifiers(($event) => (_ctx.changePage(page)), ["prevent"])
                                    }, _toDisplayString(page), 9, _hoisted_35)
                                ], 2));
                            }), 128)),
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Next",
                                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.changePage(_ctx.currentPage + 1)), ["prevent"]))
                                }, [...(_cache[16] || (_cache[16] = [
                                        _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                    ]))])
                            ], 2)
                        ])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("h5", _hoisted_40, " Historique d'utilisation - " + _toDisplayString(_ctx.categorieSelected?.code), 1),
                        _cache[17] || (_cache[17] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close shadow-none",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                        (_ctx.isHistoryLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                _createVNode(_component_LoaderComponent)
                            ]))
                            : (_ctx.couponHistory.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [...(_cache[18] || (_cache[18] = [
                                        _createElementVNode("p", { class: "text-muted mb-0" }, "Aucune utilisation enregistrée pour ce coupon.", -1)
                                    ]))]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                    _createElementVNode("table", _hoisted_45, [
                                        _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", {
                                                    scope: "col",
                                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                                                }, "DATE"),
                                                _createElementVNode("th", {
                                                    scope: "col",
                                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                                }, "CLIENT"),
                                                _createElementVNode("th", {
                                                    scope: "col",
                                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                                }, "RESTAURANT"),
                                                _createElementVNode("th", {
                                                    scope: "col",
                                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                                                }, "COMMANDE")
                                            ])
                                        ], -1)),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.couponHistory, (item, idx) => {
                                                return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                                    _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.convertDateCreate(item.usedAt)), 1),
                                                    _createElementVNode("td", _hoisted_47, _toDisplayString(item.userName), 1),
                                                    _createElementVNode("td", _hoisted_48, _toDisplayString(item.restaurantName), 1),
                                                    _createElementVNode("td", _hoisted_49, [
                                                        _createElementVNode("span", _hoisted_50, _toDisplayString(item.orderNif), 1)
                                                    ])
                                                ]));
                                            }), 128))
                                        ])
                                    ])
                                ]))
                    ]),
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "modal-footer p-20 p-md-25" }, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-secondary rounded-0 px-4",
                            "data-bs-dismiss": "modal"
                        }, " Fermer ")
                    ], -1))
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "modal-header" }, [
                        _createElementVNode("h5", {
                            class: "modal-title",
                            id: "confirmModalLabel"
                        }, " Confirmation de suppression "),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        })
                    ], -1)),
                    _createElementVNode("div", _hoisted_54, [
                        _cache[22] || (_cache[22] = _createElementVNode("i", { class: "fas fa-exclamation-triangle warning-icon" }, null, -1)),
                        _createElementVNode("p", _hoisted_55, [
                            _createTextVNode(_toDisplayString(_ctx.$t('lists.confirmDeleteCoupon')), 1),
                            _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('lists.confirmDeleteText')), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("button", _hoisted_57, [
                            _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fas fa-times me-2" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('lists.cancel')), 1)
                        ]),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger",
                            onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.executeDeleteAction())),
                            "data-bs-dismiss": "modal"
                        }, [
                            _cache[24] || (_cache[24] = _createElementVNode("i", { class: "fas fa-trash-alt me-2" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('lists.delete')), 1)
                        ])
                    ])
                ])
            ])
        ])
    ], 64));
}
